import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

const CONTEXT = 'user';

const fetchUsersRelatedToRetailer = ({ userId, currentRetailer, ...params }) => {
  const { url } = DepsService.rest.account.entries;
  const queryParams = { ...params, currentRetailer };
  const urlParams = { userId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

const fetchAllUsers = (requestParams) => {
  const { url } = DepsService.rest.accounts.lotteryRep.entries;

  return DepsService.restSrv.list(CONTEXT, url, requestParams);
};

export const fetchUsers = ({ userId, currentRetailer, ...params }) => {
  if (userId) {
    return fetchUsersRelatedToRetailer({ userId, currentRetailer, ...params });
  }
  return fetchAllUsers({ ...params });
};

export const bulkUpdate = async (params) => {
  const { url } = DepsService.rest.users.bulkUpdate;

  return DepsService.restSrv.create(CONTEXT, url, params);
};

export const createUser = (user) => {
  const { url } = DepsService.rest.account.create;

  return DepsService.restSrv.create(CONTEXT, url, user);
};

export const downloadUsersReport = ({ lotteryRepId, extension, ...queryParams }) => {
  const { url } = DepsService.rest.accounts.downloadReport;
  const urlParams = { };
  const headers = appHelpers.setHeader(extension);

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);
};



// WEBPACK FOOTER //
// ./src/modules/user/resources/users.api.js